<template>
  <div>
	 <b-toast
		id="toast-check-modal-confirm-request"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		<b-toast
		id="toast-equis-modal-confirm-request"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-equis.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		<b-modal id="modal-confirm" :title="$t('title.2')" 
			:hide-footer="false" 
			:hide-header="false"
			:hide-body="true" 
			:centered="true" 
			:no-close-on-esc="true">
		<template #modal-header="{ close }">
        	<img class="close" src="@/assets/img/close_red.png" @click="close()">
      </template>
		<p class="text-center mb-0" v-if="flagState" >{{$t('modals.modalConfirm.text-5')}}</p>	
		<div v-else>
			<p v-if="type == 2" class="text-center mb-0"> {{$t('modals.modalConfirm.text')}} {{nameTeacher}} ?</p>	
			<p v-else class="text-center mb-0"> {{$t('modals.modalConfirm.text-2')}}  {{nameTeacher}} ?</p>
		</div>
      <template #modal-footer>
        <b-button variant="danger" @click="$bvModal.hide('modal-confirm')">{{$t('modals.modalConfirm.button-cancel')}}</b-button>
        <b-button @click="confirmRequest" variant="primary" :class="{ loading: showSpinnerSave }">{{$t('modals.modalConfirm.button')}}</b-button>
      </template>
	  </b-modal>
	  <b-modal id="modal-new conflict" :title="$t('title.3')"   :centered="true">
		  	  <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()">
	
      	<h5 class="text-center" >{{$t('modals.modalConfirm.text-3')}}</h5>	
      </template>
     
      <template #modal-footer>
        <b-button @click="confirmNewConflict" variant="primary" :class="{ loading: showSpinnerConflict }">{{$t('modals.modalConfirm.text-4')}}</b-button>
      </template>
	</b-modal>
</div>
   
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as Constants from "@/assets/js/appConstants";
import { convertTimeCalendarEvents } from '@/assets/js/util.js';

export default {
	name:"modalConfirm",
	data() {
		return {
			flagState:false,
			SelectBeginningDate: new Date(),
			nameTeacher : '',
			flagPlanTest: false,
			typeOption: 1,
			showSpinnerConflict: false,
			showSpinnerSave:false,
			message: '',
			dataTeacher : {},
			listCalendar : [],
			flagEdited : false,
			lang: localStorage.getItem('lang')
		}
	},
	// id : es el id de la contrapropuesta
	props:{
		id:Number,
		groupId:Number,
		type: Number,
		typeResponseEvent: Number,
		messageValidate: String
	},
	created() {
	},
	methods: {
		confirmNewConflict(){
			this.showSpinnerConflict = true
		
				let data = {
					SchedulesOptionId: this.typeOption,
					GroupScheduleCounterProposalId : this.id,
					UserMail : this.$store.state.user.email
					
				};
				baseInstanceAxios
				.get(`${this.apiURL}/resources/GroupScheduleCounterProposal/NewConflictsScheduleCounterByPublicPrivate`, {
					params : data
				})
				.then((response) => {
					this.showSpinnerConflict = false
					this.$bvModal.hide('modal-new conflict');
					this.$emit('updateSchedule')

					
				}).catch(err =>{
					this.showSpinnerConflict = false
					this.message = this.$t('modalConfirm.text.1');
					
					this.$bvToast.show("toast-equis-modal-confirm-request");
					console.log("err : ",err.response)
            	}) ;
		},
		async confirmRequest(){
			this.showSpinnerSave = true;

			if(this.type ==1){
				// ACEPTAR PROPUESTA ENVIADA POR EL PROFESOR
				let data = {
					ScheduleCounterId: this.id,
					PersonStudentId : this.$store.state.user.personStudentId,
					Usuario:  this.$store.state.user.email,
					FlagChangeTeacher: this.flagEdited
				};
			
					/*this.$emit('updateSchedule')
				this.$bvModal.hide('modal-confirm')
				*/
				
				baseInstanceAxios
				.get(`${this.apiURL}/resources/GroupsCoursesLessons/SaveScheduleStudentSteachers`, {
					params : data
				})
				.then((response) => {
				
					let value = response.data.value
					this.showSpinnerSave = false;

					this.$bvModal.hide('modal-confirm');
					console.log("value: ",value)
					if(value == -3){
						this.$bvModal.show('modal-new conflict');
					}
					if(value == -2){
						this.message = this.$t('modalConfirm.text.2')
						this.$bvToast.show("toast-equis-modal-confirm-request");
					}

					if(value > 0){
						this.message = this.$t('modalConfirm.text.3')
						this.$bvToast.show("toast-check-modal-confirm-request");
						this.$emit('updateSchedule')
					}
					
				}).catch(err =>{
					this.showSpinnerSave = false;
					this.message = this.$t('modalConfirm.text.4');
					
					this.$bvToast.show("toast-equis-modal-confirm-request");
					console.log("err : ",err.response)
            	}) ;
					
			}else{
				// ENVIAR PROPUESTA AL PROFESOR
				let arraySend = this.listCalendar.filter((currentValue)=>{
					return currentValue.request 
				})
			
				let arrayDetaild = []
				arraySend.forEach(element => {
					let json = {
						StartDate:element.StartDate,
						EndDate:element.EndDate
						//StateClassId:element.stateClassId,
						//FlagUpdate:element.flagUpdate
					}
					arrayDetaild.push(json)
				});

				let data = {
					GroupScheduleCounterProposalId: this.dataTeacher.id,
					Code: Constants.TYPE_PROPOSAL_SEND.STUDENT_PROPOSAL.CODE,
					Value: Constants.TYPE_PROPOSAL_SEND.STUDENT_PROPOSAL.VALUE,
					GroupId: this.groupId,
					ScheduleCounterDetail: arrayDetaild,
					UserMail : this.$store.state.user.email,
					FlagPlanTest : this.flagPlanTest,
					BeginningDate: this.SelectBeginningDate,
				};

		 
				convertTimeCalendarEvents(data.ScheduleCounterDetail, this.$store.state.user.timeZoneName, this.$moment);
			 

				if(this.id != 0){
					let flagContinue = await this.validateCounterProposal(this.id);
					if(!flagContinue) {
						return;
					}
				}

				baseInstanceAxios
				.post(`${this.apiURL}/resources/GroupScheduleCounterProposal/SaveScheduleCounter`, data)
				.then((response) => {
					this.showSpinnerSave = false;
					this.message = this.$t('reusables.msg-schedule-sent-success');
					this.$bvToast.show("toast-check-modal-confirm-request");
					this.$emit('updateSchedule')
					this.$bvModal.hide('modal-confirm');
				});
			}
		},
		showModal(teacher,listCalendar,typeOption, flagPlanTest,flagEdited,beginningDate,arraySend,flagState, nameTeacher){
			this.flagState = flagState
			 
			this.nameTeacher = nameTeacher
 
			this.listCalendar = listCalendar;
			this.dataTeacher = teacher;
			this.typeOption = typeOption;
			this.flagEdited = flagEdited
			this.flagPlanTest = flagPlanTest
			this.SelectBeginningDate = beginningDate
		
			let sum = 0
			if(flagPlanTest && arraySend.length > 0){
				arraySend.forEach(element => {
					let testClassDate = new Date(element.StartDate);
					let currentDate = new Date();
					if(testClassDate <= currentDate){
						sum++
					}
					
				});

				if(sum>0){
						this.message = this.$t('modalConfirm.text.5');	
						this.$bvToast.show("toast-equis-modal-confirm-request");
				}
				else{
					this.$bvModal.show("modal-confirm");
				}	
				
			}else{
				this.$bvModal.show("modal-confirm");
			}
		},
		async validateCounterProposal(groupScheduleCounterProposalId){
            let flagContinue = false;
			let flagType = false;//parametro para validar la solicitud y no la propuesta o contrapropuesta
            let params = { groupScheduleCounterProposalId ,flagType};

            await baseInstanceAxios
            	.get(`${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateCounterProposalStudentByActive`, {params})
                .then((response) => {
                	flagContinue = response.data.return;
                    if(!response.data.return){
                    	let entity = response.data.entity;

                        if(entity.flagProposalAcepted){
                        	this.messageValidate = this.$t("reusables.student-edited-schedule-11"); //GH => Cambiar
                            this.typeResponseEvent = 1;
                        }else{
                        	let objectStatus = Constants.STATUS_VALIDATION_COUNTER_PROPOSAL[entity.typeResult];
                            if(objectStatus)
                            	this.messageValidate = this.lang == 'es' ? objectStatus.ES : objectStatus.EN;

							if(entity.flagCount){
                            	if(this.typeOption == 1){
                                	this.typeResponseEvent = (entity.countProposalMassive == 0) ? 2 : 3;
								}else {
                                	this.typeResponseEvent = (entity.countProposalDirects == 0) ? 4 : 3;
                                }
                            }else{
                            	this.typeResponseEvent = 1;
                            }
                        }
                        this.$bvModal.show("modal-conflict-validate");
                    }
                });
            return flagContinue;
        }
	}

}
</script>